export default __webpack_public_path__ + "static/chenoweth-b01633386bf683828aeab06652cadf9a.jpg";